// @flow
/**
 */
class IllegalReturnException extends Error {
  constructor(message: string) {
    super(message);
    this.name = "IllegalReturnException";
  }
}

export default IllegalReturnException;
